export const clientCode: string="VESTCOREMPLOYER";